import { DetailWrapper } from "../../../../../features/ui"
import { CustomerTypeDetail } from "./customerTypeDetail"

export const CustomerTypeDetailLoader = () => (
    <DetailWrapper>
        <CustomerTypeDetail />
    </DetailWrapper>
)
